var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/BetslipHistory.vue": 7238,
	"./frontend/BodyFB.vue": 2280,
	"./frontend/ContactUs.vue": 477,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 6711,
	"./frontend/History.vue": 5091,
	"./frontend/Home.vue": 3187,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Index.vue": 8863,
	"./frontend/Live.vue": 6230,
	"./frontend/MainMenu.vue": 4694,
	"./frontend/MaungFB.vue": 2135,
	"./frontend/Promotion.vue": 7824,
	"./frontend/Setting.vue": 2531,
	"./frontend/VideoLink.vue": 8236,
	"./frontend/Withdraw.vue": 5888,
	"./frontend/auth/Login.vue": 3664,
	"./frontend/auth/Rule.vue": 2251,
	"./frontend/components/AccountSelect.vue": 6311,
	"./frontend/components/DataTable.vue": 3639,
	"./frontend/components/FBPreviewVoucher.vue": 8612,
	"./frontend/components/FBVoucher.vue": 6418,
	"./frontend/components/FootballTeamCard.vue": 7910,
	"./frontend/components/GroupBox.vue": 3593,
	"./frontend/components/InputSelectDrawModal.vue": 7621,
	"./frontend/components/LuckyWheel.vue": 4223,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 4032,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 9299,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 8796,
	"./frontend/components/Voucher.vue": 9247,
	"./frontend/normal-user/2d/2d.vue": 2042,
	"./frontend/normal-user/2d/ClosedDays.vue": 5620,
	"./frontend/normal-user/2d/Home.vue": 8780,
	"./frontend/normal-user/2d/Winner.vue": 513,
	"./frontend/normal-user/3d/3d.vue": 681,
	"./frontend/normal-user/3d/Home.vue": 9750,
	"./frontend/normal-user/DreamBooks.vue": 6547,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 9666,
	"./frontend/normal-user/game/Fishing.vue": 8085,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 2931,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;